import { FC } from 'react';
import classNames from 'classnames';

import { TEXTS } from 'application/pages/BillingPage/renderer/texts';
import CommonUtils from 'application/utils/CommonUtils';

import Text from '@zvuk-b2b/react-uikit/ui/Text';
import IconCoinsAlt from '@zvuk-b2b/react-uikit/ui/icons/CoinsAlt';
import Info, { InfoTypes } from '@zvuk-b2b/react-uikit/ui/Info';

import { AmountProps } from './types';
import useAmountViewModel from './useAmountViewModel';

import styles from './index.module.scss';

const Amount: FC<AmountProps> = ({
  selectedPriceItemPeriodId,
  periodPayFrequencyMonth,
  currentPeriodId,
  withPricePlanAlias,
}) => {
  const viewModel = useAmountViewModel({
    selectedPriceItemPeriodId,
    currentPeriodId,
    withPricePlanAlias,
    periodPayFrequencyMonth,
  });

  if (!viewModel) {
    return (
      <Text
        elementId="title_subscription_cost_by_price_period_id"
        className={styles.amountSkeleton}
        isLoading
        as="div"
      />
    );
  }

  const {
    subscriptionCostByPricePlanPeriod,
    nextBillingAmount,
    licenseCostLoading,
    withDiscountAndCurrentSelected,
    withInactiveLicensesInfo,
  } = viewModel;

  return (
    <div
      className={classNames(styles.container, {
        [styles.containerVertical]: withInactiveLicensesInfo,
      })}>
      <div className={styles.amountTitle}>
        <IconCoinsAlt className={styles.icon} />
        <span>{TEXTS.PRICE_PLAN_LIST_ITEM_RATE_TEXT(withPricePlanAlias)}</span>
      </div>

      {withInactiveLicensesInfo ? (
        <>
          <Info
            type={InfoTypes.ERROR}
            className={styles.info}>
            {TEXTS.RATES_BLOCK_INACTIVE_SUBSCRIPTION_INFO}
          </Info>
        </>
      ) : (
        <div className={styles.amountWithPeriod}>
          <Text
            elementId="title_subscription_cost_by_price_period_id"
            className={licenseCostLoading ? styles.amountSkeleton : ''}
            isLoading={licenseCostLoading}
            as="div">
            {TEXTS.BILLING_LICENSES_AMOUNT(
              CommonUtils.numberWithSeparation(
                withDiscountAndCurrentSelected ? nextBillingAmount : subscriptionCostByPricePlanPeriod
              )
            )}
          </Text>

          <div className={styles.period}>
            {periodPayFrequencyMonth === 1 ? TEXTS.RATES_BLOCK_RATES_MONTH_TEXT : TEXTS.RATES_BLOCK_RATES_YEAR_TEXT}
          </div>
        </div>
      )}
    </div>
  );
};

export default Amount;
